import React, { useState } from "react";
import { DealLegalEntityInvestment } from "../../../../api/generated-api";
import { currencyFormat, currencyRoundUp } from "../../../../helpers/utils";
import { Box, Typography } from "@mui/material";
import { formatDate } from "../../../../helpers/utilsTS";
import WireReceivedPopup from "../../../popup/wireReceivedPopup/WireReceivedPopup";
import { updateDealLegalEntityInvestment } from "../../../../api/deals/investors";
import { DealRouteProps } from "../../../../routes/dealsRouting/DealsRoutes";
import { useParams } from "react-router-dom";

type WireStatusProps = {
  isUserCompanyMember: boolean;
  dealLegalEntityInvestment: DealLegalEntityInvestment;
  onWireDateChange: (
    dealLegalEntityInvestmentId: number,
    wireDate: string
  ) => void;
};

const InvestmentAndWireStatus = ({
  isUserCompanyMember,
  dealLegalEntityInvestment,
  onWireDateChange,
}: WireStatusProps) => {
  const { orgId, dealId } = useParams<DealRouteProps>();
  const [showWireModal, setShowWireModal] = useState(false);

  return (
    <Box
      data-testid="investment-and-wire-status"
      key={`investment-${dealLegalEntityInvestment.id}`}
    >
      {dealLegalEntityInvestment.targetCashInvestment && (
        <Box display={"flex"} flex={1}>
          <Box flex={1} marginRight={3}>
            <Box>
              <Typography variant="table">Exact Wire Amount</Typography>
              {dealLegalEntityInvestment.exactWireAmount > 0 && (
                <Typography data-testid="wire-amount">
                  {currencyFormat(
                    currencyRoundUp(dealLegalEntityInvestment.exactWireAmount)
                  )}
                </Typography>
              )}
            </Box>
          </Box>
          <Box flex={1}>
            <Box data-testid="wire-date">
              <Typography variant="table">Received On</Typography>

              {isUserCompanyMember &&
                !dealLegalEntityInvestment.wireDateReceived && (
                  <Box
                    onClick={() => {
                      setShowWireModal(true);
                    }}
                  >
                    <Typography variant="tableLink">Add Date</Typography>
                  </Box>
                )}
              {isUserCompanyMember &&
                dealLegalEntityInvestment.wireDateReceived && (
                  <Box
                    onClick={() => {
                      setShowWireModal(true);
                    }}
                  >
                    <Typography variant="tableLink">
                      {formatDate(
                        new Date(dealLegalEntityInvestment.wireDateReceived)
                      )}
                    </Typography>
                  </Box>
                )}
              {!isUserCompanyMember &&
                !dealLegalEntityInvestment.wireDateReceived && (
                  <Box>not yet received</Box>
                )}
              {!isUserCompanyMember &&
                dealLegalEntityInvestment.wireDateReceived && (
                  <Box>
                    {formatDate(
                      new Date(dealLegalEntityInvestment.wireDateReceived)
                    )}
                  </Box>
                )}
            </Box>
          </Box>
        </Box>
      )}
      {dealLegalEntityInvestment.purchaseAmount && (
        <Box>
          <Box>
            <Typography variant="table">SAFE Conversion Amount</Typography>
            <Typography data-testid={"safe-conversion-amount"}>
              {currencyFormat(
                currencyRoundUp(dealLegalEntityInvestment.purchaseAmount)
              )}
            </Typography>
          </Box>
        </Box>
      )}
      {showWireModal && (
        <WireReceivedPopup
          open={true}
          onClose={() => {
            setShowWireModal(false);
          }}
          wireName={dealLegalEntityInvestment.name}
          wireAmount={dealLegalEntityInvestment.exactWireAmount}
          existingValue={
            dealLegalEntityInvestment.wireDateReceived
              ? new Date(dealLegalEntityInvestment.wireDateReceived)
              : undefined
          }
          onMark={(selectedWireDate) => {
            const data = {
              wireDateReceived: selectedWireDate,
            };

            onWireDateChange(dealLegalEntityInvestment.id, selectedWireDate);

            // call API to update wire date
            updateDealLegalEntityInvestment(
              +orgId,
              +dealId,
              dealLegalEntityInvestment.investorId,
              dealLegalEntityInvestment.id,
              data
            );

            setShowWireModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default InvestmentAndWireStatus;
